import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import Backend from '../../Backend';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import WalletInformationCardComponent from './Cards/walletInformation';
import WalletTransactionsImportantCardComponent from './Cards/walletTransactionImportant';
import WalletAddressesCardComponent from './Cards/walletAddresses';
import Connection from '../../Calls';

class WalletsInformationIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hideShowExpanded: false,
      hideShowExpandedTransaction: false,
      loading:true,
      walletsinformation: '',
      refresh: false,
      planInfo: [],
      coinsInfo: [],
      withdrawal:{}
    }
    this.handleExpanded = this.handleExpanded.bind(this);
    this.handleExpandedTransaction = this.handleExpandedTransaction.bind(this);
    this.refreshTableTransactions = this.refreshTableTransactions.bind(this);
    this.refresherInformation = this.refresherInformation.bind(this);
  }

  componentWillMount() {
    this.getinformation();
  }

  refresherInformation() {
    const self = this;
    self.getinformation();
  }

  refreshTableTransactions(value) {
    this.setState({
      refresh: value
    });
  }

  handleExpanded(val) {
    this.setState({
      hideShowExpanded: val
    });
  }

  handleExpandedTransaction(val) {
    this.setState({
      hideShowExpandedTransaction: val
    });
  }

  getinformation() {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.WalletsInformation(localStorage.getItem('email'), localStorage.getItem('token'), idWallet, response.payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            walletsinformation: response.payload,
            loading:false,
          });
        } else {
          self.setState({
            walletsinformation: "",
            loading:false,
          });
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });

      Backend.GroupInformationPlanInfo(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            planInfo: response.payload.plan,
            coinsInfo: response.payload.coins,
            withdrawal: response.payload.withdraw,
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });

    });

  }

  render() {
    if (this.state.loading) {
      return (
        <div>
          <NavbarComponent data={this.props} selected="wallets" logged={true} />
          <RenovateTokenAlert data={this.props} />
          <div className="container-withouth-data-wallets">
            <p className="title-withouth-data-wallets">Loading...</p>
          </div>
          
        </div >
      );
    } else if (this.state.walletsinformation !== "") {
      return (
        <div>
          <NavbarComponent data={this.props} selected="wallets" logged={true} />
          <RenovateTokenAlert data={this.props} />
          <div className="contenedor-fondo-firebit">
            {
              (this.state.walletsinformation) &&
              <Container fluid style={{ position: "relative" }}>
                <Row>
                  <Col md={4}>
                    <Row>
                      <Col md={12}>
                        <WalletInformationCardComponent {...this.state} traductions={this.props.traductions} refresherInformation={this.refresherInformation} refreshTableTransactions={this.refreshTableTransactions} walletsinformation={this.state.walletsinformation} />
                      </Col>
                      <Col md={12}>
                        <WalletTransactionsImportantCardComponent traductions={this.props.traductions} redirect={this.props.data.history} refreshTableTransactions={this.refreshTableTransactions} refresh={this.state.refresh} walletsinformation={this.state.walletsinformation} hideShowExpandedTransaction={this.state.hideShowExpandedTransaction} handleExpandedTransaction={this.handleExpandedTransaction} />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={8}>
                    <WalletAddressesCardComponent {...this.state} traductions={this.props.traductions} redirect={this.props.data.history} walletsinformation={this.state.walletsinformation} hideShowExpanded={this.state.hideShowExpanded} handleExpanded={this.handleExpanded} />
                  </Col>
                </Row>
                {/* <Row>
                  <Col md={12}>
                    <div className="container-shadow-card-wallets-information">
                      kmkmkmk
                    </div>
                  </Col>
                </Row> */}
                {/* <Row className={(this.state.hideShowExpandedTransaction) ? "reducirHeight" : "volverHeight"}>
                  <Col md={4}>
                    <Row style={(this.state.hideShowExpanded || this.state.hideShowExpandedTransaction) ? { display: "none" } : { display: "" }}>
                      <Col md={12}>
                        <WalletInformationCardComponent walletsinformation={this.state.walletsinformation} />
                      </Col>
                    </Row>
                    <Row style={(this.state.hideShowExpanded || this.state.hideShowExpandedTransaction) ? { display: "none" } : { display: "" }}>
                      <Col md={12}>
                        <WalletSettingsCardComponent refresherInformation={this.refresherInformation} refreshTableTransactions={this.refreshTableTransactions} walletsinformation={this.state.walletsinformation} />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={8}>
                    <Row style={(this.state.hideShowExpandedTransaction) ? { display: "none" } : { display: "" }}>
                      <Col md={12}>
                        <WalletAddressesCardComponent walletsinformation={this.state.walletsinformation} hideShowExpanded={this.state.hideShowExpanded} handleExpanded={this.handleExpanded} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row style={(this.state.hideShowExpanded) ? { display: "none" } : { display: "" }}>
                  <Col md={12}>
                    <WalletTransactionsCardComponent refreshTableTransactions={this.refreshTableTransactions} refresh={this.state.refresh} walletsinformation={this.state.walletsinformation} hideShowExpandedTransaction={this.state.hideShowExpandedTransaction} handleExpandedTransaction={this.handleExpandedTransaction} />
                  </Col>
                </Row> */}
              </Container>
            }
          </div>
          
        </div >
      );
    } else {
      return (
        <div>
          <NavbarComponent data={this.props} selected="wallets" logged={true} />
          <RenovateTokenAlert data={this.props} />
          <div className="container-withouth-data-wallets">
            <p className="title-withouth-data-wallets">The wallet information does not exist or is invalid.</p>
          </div>
          
        </div>
      );
    }
  }
} export default WalletsInformationIndex;
